<div (click)="back()" class="close-action"></div>
